<template>
  <div :key="account">
    <v-app-bar
      color="primary"
      dark
    >
      <v-container class="py-0 fill-height">
        <router-link :to="{ name: 'Home' }" class="d-flex align-center">
          <h1 class="white--text" v-if="censored">MyGallery</h1>
          <v-img
            v-else
            alt="Genshin Hentai"
            class="shrink mr-2"
            contain
            :src="require('@/assets/logo.png')"
            transition="scale-transition"
            width="120"
          />
        </router-link>

        <v-spacer></v-spacer>

        <div class="d-none d-md-block">
          <v-btn class="ml-2" :to="{ name: 'Gallery' }" text>
            <span class="mr-2">Gallery</span>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-btn>
          <v-btn v-if="!censored" class="ml-2" :to="{ name: 'Upload' }" text>
            <span class="mr-2">Upload</span>
            <v-icon>mdi-upload</v-icon>
          </v-btn>
          <!-- <v-btn v-if="!account" class="ml-2" :to="{ name: 'Login' }" text>
            <span class="mr-2">Login</span>
            <v-icon>mdi-login</v-icon>
          </v-btn>
          <v-btn v-if="!account" class="ml-2" :to="{ name: 'Register' }" text>
            <span class="mr-2">Register</span>
            <v-icon>mdi-account-edit</v-icon>
          </v-btn>
          <v-btn v-if="account" class="ml-2" :to="{ name: 'Account' }" text>
            <span class="mr-2">{{ account }}</span>
            <v-icon>mdi-account-edit</v-icon>
          </v-btn>
          <v-btn v-if="account" class="ml-2" @click="logout" text>
            <span class="mr-2">Logout</span>
            <v-icon>mdi-logout</v-icon>
          </v-btn> -->
        </div>

        <v-app-bar-nav-icon class="d-md-none" @click="drawer = true"></v-app-bar-nav-icon>
      </v-container>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" absolute temporary>
      <v-list nav dense>
        <v-list-item-group>
          <v-list-item :to="{ name: 'Home' }">
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item>

          <v-list-item :to="{ name: 'Gallery' }">
            <v-list-item-icon>
              <v-icon>mdi-view-dashboard</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Gallery</v-list-item-title>
          </v-list-item>

          <v-list-item v-if="!censored" :to="{ name: 'Upload' }">
            <v-list-item-icon>
              <v-icon>mdi-upload</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Upload</v-list-item-title>
          </v-list-item>

          <!-- <v-list-item v-if="!account" :to="{ name: 'Login' }">
            <v-list-item-icon>
              <v-icon>mdi-login</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Login</v-list-item-title>
          </v-list-item>

          <v-list-item v-if="!account" :to="{ name: 'Register' }">
            <v-list-item-icon>
              <v-icon>mdi-account-edit</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Register</v-list-item-title>
          </v-list-item>

          <v-list-item v-if="account" :to="{ name: 'Account' }">
            <v-list-item-icon>
              <v-icon>mdi-account-edit</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ account }}</v-list-item-title>
          </v-list-item>

          <v-list-item v-if="account" @click="logout">
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item> -->
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import jwt_decode from 'jwt-decode'

export default {
  data: () => ({
    drawer: false,
    account: ''
  }),
  computed: {
    censored () {
      return process.env.VUE_APP_CENSORED === 'true'
    }
  },
  methods: {
    logout () {
      Cookies.remove('authentication')
      this.$root.$emit('header:update')

      if (this.$route.name !== 'Home') {
        this.$router.push({ name: 'Home' })
      }
    },
    updateToken () {
      const token = Cookies.get('authentication')

      if (token) {
        const data = jwt_decode(token)
        this.account = data.name
      } else {
        this.account = ''
      }
    }
  },
  created () {
    this.$root.$on('header:update', this.updateToken)
    this.$root.$emit('header:update')
  },
  beforeDestroy () {
    this.$root.$off('header:update', this.updateToken)
  }
}
</script>